import { makeStyles } from "@material-ui/core";
import colors from "Styles/colors";

const useStyles = makeStyles(theme => ({
  root: {
    border: `1px solid ${theme.palette.primary.main}`,
    backgroundColor: colors.whiteBlue,
    marginBottom: 66,
    padding: 44,
    minHeight: 400,
    height: "100%",
    display: "flex",
  },
  icon: {
    color: colors.black,
    display: "block",
    margin: "0 auto 11px auto",
  },
}));

export default useStyles;
